<template>
  <div>
    <v-dialog persistent v-model="sahapandialog" width="550px">
      <template v-slot:activator="{ on }">
        <v-btn color="red" style="color: white" v-on="on">เพิ่มคะแนนสั่งซื้อ</v-btn>
      </template>
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="close" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <label>ช่องทาง</label>
          <div class="pa-1" :class="{ 'has-error': errors.has('channel') }">
            <v-select
              :data-vv-as="$t('สินค้า')"
              v-validate="'required'"
              name="channel"
              v-model="input.channel"
              :items="channelOptions"
              outline
              single-line
            ></v-select>
            <span class="text-error" v-if="errors.has('product')">{{
              errors.first('channel')
            }}</span>
          </div>

          <label>สินค้า</label>
          <div
            :style="{ 'min-height': expandForSelect ? '300px' : '' }"
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('product') }"
          >
            <multiselect
              :data-vv-as="$t('สินค้า')"
              v-validate="'required'"
              name="product"
              v-model="input.product"
              :options="product"
              group-values="items"
              group-label="header"
              @open="expandForSelect = true"
              @close="expandForSelect = false"
              placeholder="Type to search"
              track-by="name"
              label="name"
            >
              <span slot="noResult"
                >Oops! No elements found. Consider changing the search query.</span
              >
            </multiselect>
            <span class="text-error" v-if="errors.has('product')">{{
              errors.first('product')
            }}</span>
          </div>

          <div class="form-control pa-1" :class="{ 'has-error': errors.has('price') }">
            <label>ราคา</label>
            <input
              :data-vv-as="$t('price')"
              v-validate="'required'"
              name="price"
              type="number"
              v-model="input.price"
            />
            <span class="text-error" v-if="errors.has('price')">{{ errors.first('price') }}</span>
          </div>
          <v-layout row wrap>
            <v-flex xs6>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('quantity') }">
                <label>จำนวน</label>
                <input
                  :data-vv-as="$t('quantity')"
                  v-validate="'required'"
                  name="quantity"
                  type="number"
                  v-model="input.quantity"
                />
                <span class="text-error" v-if="errors.has('quantity')">{{
                  errors.first('quantity')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('point') }">
                <label>คะแนน</label>
                <input
                  :data-vv-as="$t('point')"
                  v-validate="'required'"
                  name="point"
                  type="number"
                  v-model="input.point"
                />
                <span class="text-error" v-if="errors.has('point')">{{
                  errors.first('point')
                }}</span>
              </div>
            </v-flex>
          </v-layout>
          <div>
            <v-btn :loading="loading" @click="updatePoint" block depressed color="primary"
              >save</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import product from '@/assets/js/sahapanproducts.js'
import multiselect from 'vue-multiselect'
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: ['user'],
  data() {
    return {
      loading: false,
      sahapandialog: false,
      input: {
        product: '',
        channel: '',
        price: '',
        quantity: '',
        point: ''
      },
      channelOptions: ['Shopee', 'Website', 'Line', 'Lazada', 'JD Central', 'Facebook'],
      expandForSelect: ''
    }
  },
  components: {
    multiselect
  },
  computed: {
    ...mapGetters(['selectedBot']),
    product() {
      return product
    }
  },
  methods: {
    close() {
      this.sahapandialog = false
      this.input = {
        product: '',
        channel: '',
        price: '',
        quantity: '',
        point: ''
      }
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    updatePoint() {
      var data = {
        userid: this.user.id,
        point: this.input.point,
        channel: this.input.channel,
        product: this.input.product.name, // ชื่อสินค้า
        quantity: this.input.quantity,
        price: this.input.price
      }

      this.loading = true
      api.putsahapanupdatepointmanual(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.close()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/SahapanAddManual.vue